import history from "../../../utils/history";

export const goToTaxConfig = () => {
    const state = history.location?.state as { from: string }
    history.push({ pathname: "/configuration/taxes"} as any, state || undefined);
}